import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">热门话题</h2>
          <p className="mt-2 text-sm text-foreground-500">话题热议 · 追剧指南</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#cards"
              className="group inline-flex items-center gap-2 px-4 py-2.5 bg-background-50 rounded-full border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}